<template>
  <div>
    <div v-if="products.length > 1">
      <div v-for="(item, index) in displayProduct" :key="index" class="item-list f-left w-100pct pd-vtc-10px al-center dp-flex al-it-center">
        <div class="w-30pct f-left">
          <img :src="item.image" width="60%">
        </div>
        <div class="w-40pct f-left t-al-left">
          <span><b>{{ item.name }}</b></span> <br>
          <span  v-if="!item.option.includes('default')">{{ item.option }} <br> </span>
          <span>In Stock {{ item.remain }}</span> <br>
          <span v-if="parseInt(item.endOfYearPrice) === parseInt(item.price)">ราคา ฿ {{ item.price | showFullPriceFormat() }}</span>
          <span v-else>ราคา ฿ <strike>{{ item.price | showFullPriceFormat() }}</strike> {{ item.endOfYearPrice | showFullPriceFormat() }} </span> <br>
        </div>
        <div class="w-30pct f-left">
          <svg-filler class="cs-pointer" @click="addItem(item)" path="/static/svg/basket.svg" :fill="'#000000'" width="30px" height="30px" />
        </div>
      </div>
    </div>
    <div v-else-if="products.length === 1">
      <img :src="displayProduct[0].image" class="w-180px">
      <div class="f-s-16px f-w-bold">
        <span>{{displayProduct[0].name}}</span>
      </div>
      <div class="f-s-16px pd-16px">
        <p>
          {{displayProduct[0].option1}} <br>
          <span v-if="displayProduct[0].option2 !== ' : '">{{displayProduct[0].option2}} <br></span>
          stock : {{displayProduct[0].remain}} <br>
          <span v-if="parseInt(displayProduct[0].endOfYearPrice) != parseInt(displayProduct[0].price)">
            Price ฿ 
            <strike>{{ displayProduct[0].price | showFullPriceFormat() }}</strike>
            {{ displayProduct[0].endOfYearPrice | showFullPriceFormat() }}
          </span>
          <span v-else>Price ฿ {{ displayProduct[0].price | showFullPriceFormat() }}</span> <br>
        </p>
      </div>
      <div class="dp-flex jtf-ct-center">
        <div class="minus-item cs-pointer" @click="amountItem--">
          -
        </div>
        <div class="item-amout-box pd-t-6px">
          {{amountItem}}
        </div>
        <div class="add-item cs-pointer"  @click="amountItem++">
          +
        </div>
      </div>
      <div class="pd-vtc-16px">
        <div class="add-item-tab f-s-24px f-w-bold pd-8px cl-white cs-pointer" @click="addItemData(products[0])">
          Add To Cart
        </div>
      </div>
    </div>
    <div v-else class="mg-auto pd-t-100px">
      <svg-filler path="/static/svg/QR icon big.svg" class="" :fill="'#f2f2f2'" width="220px" height="220px"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'list-product',
  props: ['products', 'searchKey'],
  data () {
    return {
      amountItem: 1
    }
  },
  computed: {
    displayProduct () {
      const discount70p = ['mypos70']
      const discount50p = ['mypos50']
      const discount40p = ['mypos40']
      const discount30p = ['mypos30']
      const discount20p = ['mypos20']
      const discount85pFloor = ['gel']
      const discount70pFloor = []
      const discount50pFloor = ['sanitizer']
      const discount30pFloor = []
      const discount400 = ['mustard']
      let products = this.products
      for (let product of products) {
        const isTag = product.tags && product.tags.length > 0
        let isDiscount70p = isTag && discount70p.length > 0 ? product.tags.some(tag => discount70p.some(dis => dis === tag)) : false
        let isDiscount50p = isTag && discount50p.length > 0 ? product.tags.some(tag => discount50p.some(dis => dis === tag)) : false
        let isDiscount85pFloor = isTag && discount85pFloor.length > 0 ? product.tags.some(tag => discount85pFloor.some(dis => dis === tag)) : false
        let isDiscount70pFloor = isTag && discount70pFloor.length > 0 ? product.tags.some(tag => discount70pFloor.some(dis => dis === tag)) : false
        let isDiscount50pFloor = isTag && discount50pFloor.length > 0 ? product.tags.some(tag => discount50pFloor.some(dis => dis === tag)) : false
        let isDiscount30pFloor = isTag && discount30pFloor.length > 0 ? product.tags.some(tag => discount30pFloor.some(dis => dis === tag)) : false
        let isDiscount40p = isTag && discount40p.length > 0 ? product.tags.some(tag => discount40p.some(dis => dis === tag)) : false
        let isDiscount30p = isTag && discount30p.length > 0 ? product.tags.some(tag => discount30p.some(dis => dis === tag)) : false
        let isDiscount20p = isTag && discount20p.length > 0 ? product.tags.some(tag => discount20p.some(dis => dis === tag)) : false
        let isDiscount400 = isTag && discount400.length > 0 ? product.tags.some(tag => discount400.some(dis => dis === tag)) : false
        if (isDiscount70p) {
          product.endOfYearPrice = Math.round(parseInt(product.price) * 0.3)
        } else if (isDiscount50p) {
          product.endOfYearPrice = Math.round(parseInt(product.price) * 0.5)
        } else if (isDiscount85pFloor) {
          product.endOfYearPrice = Math.floor(parseInt(product.price) * 0.15)
        } else if (isDiscount70pFloor) {
          product.endOfYearPrice = Math.floor(parseInt(product.price) * 0.3)
        } else if (isDiscount50pFloor) {
          product.endOfYearPrice = Math.floor(parseInt(product.price) * 0.5)
        } else if (isDiscount30pFloor) {
          product.endOfYearPrice = Math.floor(parseInt(product.price) * 0.7)
        } else if (isDiscount40p) {
          product.endOfYearPrice = Math.round(parseInt(product.price) * 0.6)
        } else if (isDiscount30p) {
          product.endOfYearPrice = Math.round(parseInt(product.price) * 0.7)
        } else if (isDiscount20p) {
          product.endOfYearPrice = Math.round(parseInt(product.price) * 0.8)
        } else if (isDiscount400) {
          product.endOfYearPrice = parseInt(product.price) - 400
        } else {
          product.endOfYearPrice = parseInt(product.price)
        }
      }
      return products
    }
  },
  methods: {
    ...mapActions([
      'addItem'
    ]),
    addItemData (item) {
      for (let i = 0; i < this.amountItem; i++) {
        this.addItem(item)
      }
    }
  },
  watch: {
    amountItem (val) {
      if (val <= 0) {
        this.amountItem = 1
      }
    }
  }
}
</script>

<style scoped>
.add-item-tab {
  width: 100%;
  height: 48px;
  background-color: #27cf5a;
}
.item-list {
  border-bottom: 1px solid;
  border-color: #cfcfcf;
}
.item-amout-box {
  width: 88px;
  height: 36px;
  border: solid 1px #000000;
  font-size: 18px;
  font-weight: bold;
}
.add-item {
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  width: 36px;
  height: 36px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: #000000;
  border: solid 1px #000000;
}
.minus-item {
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  width: 36px;
  height: 36px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #000000;
  border: solid 1px #000000;
}
</style>



// WEBPACK FOOTER //
// src/views/home/ListProduct.vue